
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Load cart count from localStorage
    const updateCartCount = () => {
      const cart = JSON.parse(localStorage.getItem('cart') || '[]');
      setCartCount(cart.length);
    };

    updateCartCount();
    window.addEventListener('storage', updateCartCount);
    window.addEventListener('cartUpdated', updateCartCount);

    return () => {
      window.removeEventListener('storage', updateCartCount);
      window.removeEventListener('cartUpdated', updateCartCount);
    };
  }, []);

  const navLinks = [
    { name: 'الرئيسية', path: '/' },
    { name: 'الأقمشة', path: '/fabrics' },
    { name: 'التفصيل', path: '/tailoring' },
    { name: 'المقاسات', path: '/measurements' },
  ];

  const isHomePage = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 right-0 left-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/4083781e1a34b23bac118fadb1fef617.png"
              alt="خياط الأقمشة الكويتية"
              className="h-12 w-auto object-contain"
            />
            <div className="text-xl font-bold">
              <span className={`transition-colors ${isScrolled || !isHomePage ? 'text-accent' : 'text-white'}`}>
                خياط الأقمشة الكويتية
              </span>
            </div>
          </Link>

          {/* Navigation Links */}
          <div className="flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-lg font-medium transition-colors hover:text-secondary ${
                  location.pathname === link.path
                    ? 'text-secondary'
                    : isScrolled || !isHomePage
                    ? 'text-accent'
                    : 'text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Cart & CTA */}
          <div className="flex items-center gap-4">
            <Link
              to="/cart"
              className={`relative cursor-pointer transition-colors ${
                isScrolled || !isHomePage ? 'text-accent hover:text-secondary' : 'text-white hover:text-secondary'
              }`}
            >
              <i className="ri-shopping-cart-line text-2xl"></i>
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-secondary text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </Link>

            <a
              href="https://wa.me/96512345678"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-secondary text-white px-6 py-3 rounded-full font-medium hover:bg-opacity-90 transition-all whitespace-nowrap cursor-pointer"
            >
              احجز موعدك
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;